import Base from './base'

export default class Notes extends Base {
  allForUserId(userId) {
    return this.api.get(`people/${userId}/notes.json`)
  }

  createForUserId(userId, note) {
    return this.api.post(`people/${userId}/notes.json`, { content: note })
  }
}
